import loadSrcIndex from './src-index';
import loadAPIs from './apis';
import loadMiddlewares from './middlewares';
import loadComponents from './components';
import loadPolicies from './policies';
import loadPlugins from './plugins';
import loadAdmin from './admin';
import loadSanitizers from './sanitizers';
import loadValidators from './validators';

export default {
  loadSrcIndex,
  loadAPIs,
  loadMiddlewares,
  loadComponents,
  loadPolicies,
  loadPlugins,
  loadAdmin,
  loadSanitizers,
  loadValidators,
};
